/*
 * Copyright (c) Funtip GbR 2018.
 * Simon Oldeboershuis, Perry Prust
 */

import * as R from 'ramda';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Table } from 'reactstrap';
import { PagingComponent } from '../../../reactutils/withPagination';
import { SearchComponent } from '../../../reactutils/withSearch';
import { withTitle } from '../../../reactutils/withTitle';
import { Album } from '../../../services/playlist';
import { getSystemConfig } from '../../System/systemConfig';
import { AlbumLink } from '../AlbumLink';
import {
    albumListBackward,
    albumListFastBackward,
    albumListFastForward,
    albumListForward,
    albumListSearch,
    searchAlbum
} from './actions';
import {
    albumListSearchString,
    albumListSelector,
    albumSearchCount,
    albumSearchCurrentPos,
    albumSearchPageSize
} from './selectors';

function showAlbum(album: Album) {
    return (
        <tr key={album.id} className="d-flex">
            <td className="col-9">
                <AlbumLink albumId={album.id}>{album.name}</AlbumLink>
            </td>
            <td className="col-3">
                {album.imageId && (
                    <img src={getSystemConfig().imageUrl(album.imageId)} alt={album.name} height={25} width={25} />
                )}
            </td>
        </tr>
    );
}

const AlbumList: React.FC<{}> = () => {
    const dispatch = useDispatch();

    const albumList = useSelector(albumListSelector);

    React.useEffect(() => {
        dispatch(searchAlbum());
    }, [dispatch]);

    return (
        <>
            <div className="d-flex justify-content-between flex-wrap">
                <SearchComponent
                    onSearch={s => albumListSearch(s)}
                    searchResultCountSelector={albumSearchCount}
                    searchStringSelector={albumListSearchString}
                />
                <PagingComponent
                    onBackward={() => albumListBackward()}
                    onFastBackward={() => albumListFastBackward()}
                    onFastForward={() => albumListFastForward()}
                    onForward={() => albumListForward()}
                    searchResultCount={albumSearchCount}
                    searchResultCurrentPos={albumSearchCurrentPos}
                    searchResultPageSize={albumSearchPageSize}
                />
            </div>
            <Table striped={true} className="mt-2">
                <thead>
                    <tr className="d-flex">
                        <th className="col-9">Albumname</th>
                        <th className="col-3">Cover</th>
                    </tr>
                </thead>
                <tbody>{albumList && albumList.map(alb => showAlbum(alb))}</tbody>
            </Table>
        </>
    );
};

export default R.compose(withTitle('Album-Datenbank'))(AlbumList);
